export default __webpack_public_path__ + "static/media/template8.f1ef661e.jpg";